var option_webview_default = {
  "option": "_2mZO-",
  "user_choice": "qd6GP",
  "check": "_35nCD",
  "image": "i7L80",
  "input": "HKzu0",
  "title": "cGDE4",
  "centered": "BTJTj",
  "with_result": "_0hodN",
  "list": "VL3Aj",
  "with_image": "u8wHk",
  "progress": "JptjP",
  "progress_value": "Yjhyv",
  "label": "bKTmC",
  "cta": "cSWxQ",
  "adornment_icon": "qmoMm",
  "remove": "V4AMk",
  "removeButton": "V-gED",
  "removeButtonIcon": "om-NV",
  "overlay": "s9Myk",
  "shown": "P5pEq",
  "dark": "_4bGTU",
  "spinner": "SWnYZ",
  "spin": "_8FhM-",
  "grid": "bqgXJ"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
